
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options, prop } from "vue-class-component";
import debounce from "lodash/debounce";
import { Commodity } from "@/domain/entities/Commodity";
import { CargoController } from "../../controllers/CargoController";

class Props {
  modelValue = prop<any>({});
  placeholder = prop<string>({
    default: "Pilih tipe produk kargo"
  });
  title = prop<string>({
    default: "Tipe Produk Kargo"
  });
  status = prop<string>({
    default: ""
  });
  disabled = prop<boolean>({
    default: false
  });
  isCommodityGroup = prop<boolean>({
    default: false
  });
  keyName = prop<string>({
    default: "name"
  });
  keyValue = prop<string>({
    default: "value"
  });
}

@Options({
  emits: ["update:modelValue", "change"]
})
export default class MultipleSelectCargoProductType extends Vue.with(Props) {
  isLoadingProductCargo = true;
  listProductCargo: any[] = [];
  created() {
    // Fetch data when component is created
    this.fetchProductCargo("");
  }
  fetchProductCargo = debounce(async (search: string) => {
    this.isLoadingProductCargo = true;
    try {
      await CargoController.getCargoProductList({
        status: "active"
      });
      this.listProductCargo = CargoController.cargoProductList.data.map(
        (e: any) => ({
          name: e.cargoProductTypeCode,
          value: e.cargoProductTypeCode,
          status: e.cargoProductTypeStatus
        })
      );
    } catch (error) {
      console.error("Error fetching cargo products:", error);
    } finally {
      this.isLoadingProductCargo = false;
    }
  }, 250);
  get optionProductCargo(): Commodity[] {
    return this.listProductCargo;
  }
  onBlur() {
    this.isLoadingProductCargo = true;
  }
}
